
  declare var window: any;
  export default {
    props: {
      instructions: String
    },
    data() {
      window.wf ??= {};
      window.locations ??= {};
      let d = window.wf.DealerDirectory;
      d.locations ??= {};
      d.sortDescending = false;
      d.selectedCountry ??= '';
      d.selectedAirport ??= '';
      d.selectDiamond = false;
      d.selectTopFive = false;
      d.searchText = '';
      d.selectMap = false;
      return d;
    },
    created() {
      this.resetFilters();
      this.updateMapSelection();
    },
    methods: {
      resetFilters() {
        this.sortDescending = false;
        this.selectedCountry = '';
        this.selectedAirport = '';
        this.selectDiamond = false;
        this.selectTopFive = false;
        this.searchText = '';
        this.selectMap = false;
      },
      updateFilters() {
        var tempFilteredLocations = this.filteredLocations;
        if (this.filteredLocations.length == 0) {
          this.selectMap = false; // don't show the map if no locations found
          this.updateMapSelection();
        }
      },
      updateMapSelection() {
        if (this.selectMap == false) {
          document.querySelectorAll(".dealer-search-component .map-area").forEach(m => m.classList.add("position-absolute","opacity-0","w-100","z-n1"));
        } else {
          document.querySelectorAll(".dealer-search-component .map-area").forEach(m => m.classList.remove("position-absolute","opacity-0","w-100","z-n1"));
        }
      },
      updateMapLocations(tempFilteredLocations) {
        var tempWindowLocations = [];
        var i;
        if (tempFilteredLocations.length > 0) {
          for (i = 0; i < tempFilteredLocations.length; i++) {
            var tempLocation = tempFilteredLocations[i];
            tempWindowLocations.push(
              {
                name: tempLocation.name,
                dealerid: tempLocation.dealerid,
                isdiamond: tempLocation.isdiamond,
                address: tempLocation.city + ', ' + this.getNameOfState(tempLocation.state) + ', ' + this.getNameOfCountry(tempLocation.country),
                lat: tempLocation.lat,
                long: tempLocation.long,
              }
            )
          }
        }
        window.locations = tempWindowLocations;
        initMap();
      },
      getNameOfState(statecode) {
        let filteredStates = this.states.filter((state) => {
          return (state.code == statecode)
        })
        if (filteredStates != null && filteredStates.length > 0) {
          return filteredStates[0].name;
        }
        return statecode;
      },
      getNameOfCountry(countrycode) {
        let filteredCountry = this.countries.filter((country) => {
          return (country.code == countrycode)
        })
        if (filteredCountry != null && filteredCountry.length > 0) {
          return filteredCountry[0].name;
        }
        return countrycode;
      },
      showDealer(dealerid) {
        window.showDealer(dealerid);
      }
    },
    computed: {
      showClearButton() {
        if (!this.selectMap && !this.filtersAreDefault) {
          return true;
        }
        return false;
      },
      disableMapButton() {
        if (this.filteredDealers.length == 0) {
          return true;
        }
        return false;
      },
      filtersAreDefault() {
        if (this.selectedCountry == '' && this.selectedAirport == '' && !this.selectDiamond && !this.selectTopFive && this.searchText == '') {
          return true;
        }
        return false;
      },
      filteredLocations() {
        var tempFilteredLocations = [];

        this.filteredDealers.forEach((dealer) => {
          if (dealer.locations != null && dealer.locations.length > 0) {
            dealer.locations.forEach((location) => {
              if (location != null) {
                tempFilteredLocations.push(location);
              }
            });
          }
        });
        if (this.selectedCountry != '') {
          tempFilteredLocations = tempFilteredLocations.filter(el => el.country == this.selectedCountry);
        }
        if (this.selectedAirport != '') {
          tempFilteredLocations = tempFilteredLocations.filter(el => el.airport == this.selectedAirport);
        }

        // update locations for map whenever the filtered locations are recalculated
        this.updateMapLocations(tempFilteredLocations);

        return tempFilteredLocations;
      },
      filteredDealers() {
        var tempFilteredDealers = [...this.dealers];

        if (this.selectDiamond == true) {
          tempFilteredDealers = tempFilteredDealers.filter(el => el.isdiamond)
        }

        if (this.selectTopFive == true) {
          tempFilteredDealers = tempFilteredDealers.filter(el => el.istopfive)
        }
        if (this.searchText !== '') {
          tempFilteredDealers = tempFilteredDealers.filter(el => el.name.toLowerCase().includes(this.searchText.toLowerCase()))
        }

        tempFilteredDealers.forEach((dealer) => {
          dealer.filteredLocations = [...dealer.locations];
          if (this.selectedCountry != '') {
            dealer.filteredLocations = dealer.filteredLocations.filter(el => el.country == this.selectedCountry);
          }
          if (this.selectedAirport != '') {
            dealer.filteredLocations = dealer.filteredLocations.filter(el => el.airport == this.selectedAirport);
          }
        });

        tempFilteredDealers = tempFilteredDealers.filter(el => el.filteredLocations != null && el.filteredLocations.length > 0);

        return tempFilteredDealers;
      },
      orderedDealers() {
        var tempOrderedDealers = [...this.filteredDealers];
        if (this.sortDescending) {
          return tempOrderedDealers.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())).reverse();
        }
        return tempOrderedDealers.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      },
      orderedDealerLetters() {
        var tempOrderedDealerLetters = this.filteredDealers.map(d => d.name[0].toUpperCase());
        tempOrderedDealerLetters = tempOrderedDealerLetters.filter((value, index, self) => self.indexOf(value) === index);
        if (this.sortDescending) {
          return tempOrderedDealerLetters.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())).reverse();
        }
        return tempOrderedDealerLetters.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      }
    }
  }
